import { TrailPoint } from "../pages/Touch";

export function simplifyPoints(points: TrailPoint[], tolerance: number): TrailPoint[] {
  if (points.length <= 2) return points;

  const result: TrailPoint[] = [];
  result.push(points[0]);

  for (let i = 1; i < points.length - 1; i++) {
    const prev = result[result.length - 1];
    const curr = points[i];
    const next = points[i + 1];

    // Distance from curr to line prev->next
    const distance = perpendicularDistance(curr, prev, next);

    if (distance > tolerance) {
      result.push(curr);
    }
  }

  result.push(points[points.length - 1]);
  return result;
}

function perpendicularDistance(p: TrailPoint, a: TrailPoint, b: TrailPoint): number {
  const dx = b.x - a.x;
  const dy = b.y - a.y;

  if (dx === 0 && dy === 0) {
    // a and b are the same point
    return Math.hypot(p.x - a.x, p.y - a.y);
  }

  // Area-based distance formula
  const numerator = Math.abs(
    dy * p.x - dx * p.y + b.x * a.y - b.y * a.x
  );
  const denominator = Math.hypot(dx, dy);

  return numerator / denominator;
}
